module.exports = __webpack_public_path__ + "img/backings.3c49dccd.png";